import { FC, ReactNode } from 'react';

import { Box, Text } from '@bonusly/design-system';

interface OverlayProps {
	children: ReactNode;
}

const Overlay: FC<OverlayProps> = ({ children }) => (
	<Box position="absolute" top="0" left="0" rounded="md" width="100%" height="100%" bg="rgba(0, 0, 0, 0.5)" zIndex={1} pointerEvents="none">
		<Box position="absolute" top="50%" left="50%" transform="translate(-50%, -50%)" display="flex" alignItems="center" justifyContent="center" zIndex={2}>
			<Text fontSize="8xl" fontFamily="display" color="white">
				{children}
			</Text>
		</Box>
	</Box>
);

interface CountdownOverlayProps {
	countdown: number | null | '';
}

export const CountdownOverlay: FC<CountdownOverlayProps> = ({ countdown }) => {
	return countdown !== null ? <Overlay>{countdown}</Overlay> : null;
};
